import type { TTranslationKeys } from "$/i18n/i18n"

import { THEME } from "@/3514/theme"

import {
    EVerticalProgressBarColorStatus,
    EVerticalProgressBarFillLevel,
    EVerticalProgressBarVariant
} from "./vertical-progress-bar.types"

const VERTICAL_PROGRESS_BAR_STAR_FILLED_COLOR: string = THEME.COLORS.yellow[100]

const barFillColorMap: {
    [S in EVerticalProgressBarColorStatus]: (isActionAffected: boolean) => string
} = {
    [EVerticalProgressBarColorStatus.NotStarted]: (_isActionAffected: boolean): string => "bg-gray-400",
    [EVerticalProgressBarColorStatus.Expired]: (isActionAffected: boolean): string =>
        isActionAffected ? "bg-green-300" : "bg-green-300", // see issue: https://wisermanagers.atlassian.net/browse/WISER-5869,  https://wisermanagers.atlassian.net/browse/WISER-5343
    [EVerticalProgressBarColorStatus.InTime]: (_isActionAffected: boolean): string => "bg-green-200"
}

const defaultTooltipConfig: { [L in EVerticalProgressBarFillLevel]: keyof TTranslationKeys } = {
    [EVerticalProgressBarFillLevel.NotFilled]: "participantSide.dashboard.verticalBar.tooltip.notStarted",
    [EVerticalProgressBarFillLevel.OnePieceFilled]: "participantSide.dashboard.verticalBar.tooltip.onePieceFilled",
    [EVerticalProgressBarFillLevel.TwoPiecesFilled]: "participantSide.dashboard.verticalBar.tooltip.twoPieceFilled",
    [EVerticalProgressBarFillLevel.ThreePiecesFilled]: "participantSide.dashboard.verticalBar.tooltip.threePieceFilled"
}

const iconDimensionsMap: { [V in EVerticalProgressBarVariant]: { width: number; height: number } } = {
    [EVerticalProgressBarVariant.Standalone]: { width: 20, height: 20 },
    [EVerticalProgressBarVariant.FullBar]: { width: 15, height: 15 },
    [EVerticalProgressBarVariant.CroppedBar]: { width: 0, height: 0 }
}

const config = {
    VERTICAL_PROGRESS_BAR_STAR_FILLED_COLOR,
    barFillColorMap,
    defaultTooltipConfig,
    iconDimensionsMap
}

export { config as verticalProgressBarConfig }
